import api from './api';

export const registerUser = (data) => api.post('/auth/register', data);
export const loginUser = (data) => api.post('/auth/login', data);
export const resendOtp = (data) => api.post('/auth/resendotp', data);
export const verifyOtp = (data) => api.post('/auth/verifyotp', data);
export const vendMeter = (data) => api.post('/meters/vendelectricity', data);
export const fetchUserById = (id) => api.get('/users/fetchuserbyid', { params: { id } });
export const getMeterByUser = (data) => api.post('/meters/getusermeters', data);
export const requestMeterbyUser = (data) => api.post('/meters/requestmeters', data);
export const getUserNotifications = (userId) => api.post(`/users/getnotifications`, { userId });
export const markNotificationAsRead = (notificationId, userId) =>  api.post(`/users/marknotificationread/${notificationId}`, { userId });
export const deleteUserById = (id) => api.delete(`/users/${id}`);
export const getMeterTransactionsByUser = (userId, query) =>   api.post(`/meters/getusermetertrans`, {userId, query});
export const deleteUserRequest = (email) => api.post(`users/deleteuserrequest`, {email});
export const forgetPasswordRequest= (email) => api.post(`users/forgetpasswordrequest`, {email});
export const getMeterRequestsByUser = (userId) => api.post(`/meters/fetchmeterrequestbyuser`, { id: userId });
export const getMeterReadingsByUser = (userId) => api.get(`/meters/meterreadings/${userId}`);
export const fetchDashboardData = (data) => api.post('/users/fetchdashboarddata', data);
export const fetchAvailableMeters = (data) => api.post('/meters/getmetersnotassigned', data);
export const updateUserProfile = (data) => api.put(`/users/updateprofile`, data);
export const getPaymentsByUser = (userId) => api.post('/users/getpaymentsbyuser', { userId });
export const sendSupportMessage = (data) => api.post('/users/sendsupportmessage', data);
export const getUserSupportRequests = (userId) => api.post('/users/getsupportrequests', { userId });
export const replySupportMessage = (data) => api.post('/users/replysupportmessage', data);
export const createPayment = (data) => api.post('/users/createpayment', data);
export const getPaymentGatewayKey = () => api.post('/users/getpaymentgatewaykey');
export const requestReset = (email) => api.post('/users/requestreset', { email });
export const resetPassword = (data) => api.post('/users/resetpassword', data);
export const fetchGateway = () => api.post('/users/fetchgateway');
export const fetchAppVersions = () => api.get('/users/appversions');

// admin app versions
export const getAdminAppVersions = () => api.get('/admin/appversions');
export const getAdminAppVersion = (platform) => api.get(`/admin/appversions/${platform}`);
export const setAdminAppVersion = (platform, data) => api.post(`/admin/appversions/${platform}`, data);
export const updateAdminAppVersion = (platform, data) => api.put(`/admin/appversions/${platform}`, data);
export const deleteAdminAppVersion = (platform) => api.delete(`/admin/appversions/${platform}`);

//admin

export const loginAdmin = (data) => api.post('/admin/loginadmin', data);
export const createAdmin = (data) => api.post('/admin/createadmin', data);
export const createAdminorAgents = (data) =>api.post('/admin/createadminoragent', data)
export const createServiceAgents = (data) => api.post('/admin/create', data);
export const fetchDashboardAdminData = (data) => api.post('/admin/fetchadmindata', data);
export const fetchNormalAdminDashboardData = (data) => api.post('/admin/fetchnormaladmindata', data);
export const fetchAllMeters = () => api.get('/admin/querymeters');
export const fetchAllMetersRequest = () => api.get('/admin/getallmeterrequestsbyadmin');
export const createMeterbySuperAdmin = (data) => api.post('/meters/createmeter', data);
export const vendMeterByAdminorAgent = (data) => api.post(`/admin/vendmeterbyadmin`, data);
export const findUserById = (userId) => api.post(`/admin/fetchuserbyid`, { id: userId });
export const getWalletBalance = (adminId) => api.post(`/admin/getwalletbalance`, { id: adminId });
export const fundWalletByAdmin = (data) => api.post('/admin/fundwalletbyadmin', data);
export const getAllUsers = () => api.get('/admin/getallusers');
export const getAllAdmins = () => api.get('/admin/getalladmins');
export const getAllAgents = () => api.get('/admin/getallagents');
export const getDeductions = () => api.get('/admin/getdeductions');
export const setDeductions = (data) => api.post('/admin/setdeductions', data);
export const updateDeductions = (data) => api.put('/admin/updatedeductions', data);
export const assignMeters = (data) => api.post('/admin/assignmeters', data);
export const createGateway = (data) => api.post('/admin/creategateway', data);
export const updateGateway = (data) => api.put('/admin/updategateway', data);
export const getAllGateways = () => api.get('/admin/getallgateways');
export const getGatewayById = (gatewayId) => api.get(`/admin/gatewaybyid?id=${gatewayId}`);
export const deleteGateway = (gatewayId) => api.delete(`/admin/deletegateway?id=${gatewayId}`);
export const getAdminSupportRequests = () => api.get('/admin/supportrequests');  
export const getSupportRequestById = (requestId) => api.get(`/admin/supportrequests/${requestId}`);
export const respondToSupport = (data) => api.post('/admin/respondtosupport', data);
export const updateSupportStatus = (requestId, status) => api.put(`/admin/supportrequests/${requestId}/status`, { status });
export const deleteSupportRequest = (requestId) => api.delete(`/admin/supportrequests/${requestId}`);
export const deleteAdminUserById = (userId) => api.delete(`/admin/users/${userId}`);
export const checkTokenExpiry = (data) => api.post('/admin/checktokenexpiry', data);
export const vendByAdmin = (data) => api.post('/admin/vendbyadmin', data);
export const replySupport = (data) => api.post('/admin/replysupport', data);
export const vendMeterByAgent = (data) => api.post('/admin/vendmeterbyagent', data);

export const getLogs = (limit = 100) => api.get('/admin/logs', { params: { limit } });
export const deleteLogs = (olderThanDays) => api.delete('/admin/logs', { data: { olderThanDays } });
export const getAllTransactions = (params = {}) => api.get('/admin/transactions', { params });
export const getAnalytics = (timeRange, startDate = null, endDate = null) => {
  const apiParams = { timeRange };
  if (startDate) apiParams.startDate = startDate;
  if (endDate) apiParams.endDate = endDate;
  return api.get('/admin/analytics', { params: apiParams });
};

export const getMeterReadings = () => api.get('/admin/meterreadings');
export const getWithdrawals = () => api.get('/admin/withdrawals');
export const getPayouts = () => api.get('/admin/payouts');
export const getCronActivityLogs = () => api.get('/admin/cron-activity-logs');
export const approveMeterRequest = (data) => api.post('/admin/assignmeters', data);
export const rejectMeterRequest = (data) => api.post('/admin/assignmeters', data);
export const updateMeter = (meterId, data) => api.put(`/meter/updatemeter/${meterId}`, data);
export const createMeterWithCSV = (data) => api.post('/meter/createmeterwithcsv', data);
export const verifyTokenRecharge = (data) => api.post('/meter/verify-token-recharge', data);
export const getAllMeterTransactions = (params = {}) => api.get('/admin/metertransactions', { params });

// Health check routes
export const getHealthStatus = () => api.get('/health/health');

// Auth routes
export const sendOtp = (data) => api.post('/auth/sendotp', data);

// Additional admin routes
export const updateAdmin = (data) => api.put('/admin/updateadmin', data);
export const fundWalletByAgent = (data) => api.post('/admin/fundwalletbyagent', data);
export const fundWalletBySuperAdmin = (data) => api.post('/admin/fundwalletbysuperadmin', data);
export const fundWalletByUser = (data) => api.post('/users/fundwallet', data);
export const termiWebhook = () => api.get('/admin/termiwebhook');

// Payout routes
export const getBanks = () => api.get('/payout/banks');
export const paystackWebhook = (data) => api.post('/payout/webhook/paystack', data);
export const fetchPaymentGatewayKey = (userId) => api.post('/users/fetchgateway', { userId });
export const initializePaystackPayment = (data) => api.post('/users/initializepayment', data);
export const fetchAdminPaymentGatewayKey = (adminId) => api.post('/admin/fetchpaymentgatewaykey', { adminId });

// Account verification
export const verifyAccount = (accountNumber, bankCode) => api.post('/payout/verifyaccount', { accountNumber, bankCode });

// Delete operations (from deleteController)
export const bulkDelete = (data) => api.post('/delete/bulk', data);
export const getDeleteAuditTrail = (limit = 50, filterAdminId = null) => {
  const params = { limit };
  if (filterAdminId) params.filterAdminId = filterAdminId;
  return api.get('/delete/audit-trail', { params });
};

export const deleteServiceHealth = () => api.get('/delete/health');
export const deleteMeter = (meterId) => api.delete(`/delete/meter/${meterId}`);
export const deleteAdmin = (adminId) => api.delete(`/delete/admin/${adminId}`);
export const cancelMeterTransaction = (transactionId, reason) => api.put(`/delete/transaction/${transactionId}`, { reason });
